import { useParams } from 'react-router-dom'
import {
  Card,
  Col,
  ContentBody,
  ListItem,
  Row
} from '../../../../core/components'
import { formatCnpjCpf } from '../../../../core/utils'
import useCustomer from '../../../../services/queries/customer/useCustomer'
import { dateTimeFormat } from '../../../../utils/format/dateTimeFormat'

export const GeneralTab = () => {
  const { id }: any = useParams()
  const { data: customer, error, isLoading }: any = useCustomer(id)

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Card>
          <div style={{ fontSize: '16px' }}>
            <Row gutter={24} style={{ marginBottom: 10 }}>
              <Col span={12}>
                <ListItem label="RAZÃO SOCIAL">{customer?.data?.name}</ListItem>
                <ListItem label="FANTASIA/APELIDO">
                  {customer?.data?.nickname}
                </ListItem>
                <ListItem label="CNPJ/CPF">
                  {formatCnpjCpf(customer?.data?.employerNumber)}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="INSCRIÇÃO ESTADUAL">
                  {customer?.data?.registrationNumber}
                </ListItem>
                <ListItem label="FUNDAÇÃO/NASCIMENTO">
                  {dateTimeFormat(customer?.data?.birthday)}
                </ListItem>
                <ListItem label="CÓDIGO">{customer?.data?.id}</ListItem>
              </Col>
            </Row>
          </div>
        </Card>
      </ContentBody>
    </>
  )
}
